export const DAYS_EL = ["Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο", "Κυριακή"];
export const DAYS_EN = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// Icon keys map to lucide-react icons inside components
export const HIGHLIGHT_ICONS = [
  { key: "users", label: "Ηλικίες / Κοινό" },
  { key: "shirt", label: "Τμήματα" },
  { key: "whistle", label: "Προπονητές / Καθηγητές" },
  { key: "building", label: "Εγκαταστάσεις" },
  { key: "trophy", label: "Διοργανώσεις" },
  { key: "shield", label: "Ασφάλεια" },
  { key: "clock", label: "Ωράριο" },
  { key: "award", label: "Πιστοποιήσεις" },
  { key: "map-pin", label: "Τοποθεσία" },
  { key: "graduation", label: "Επίπεδα" },
  { key: "music", label: "Μουσική" },
  { key: "languages", label: "Γλώσσες" },
  { key: "info", label: "Άλλο" },
];

export const AMENITIES = [
  { key: "parking", label: "Parking" },
  { key: "amea_access", label: "Πρόσβαση ΑμεΑ" },
  { key: "amea_wc", label: "WC ΑμεΑ" },
  { key: "changing_rooms", label: "Αποδυτήρια" },
  { key: "showers", label: "Ντους" },
  { key: "wifi", label: "Wi-Fi" },
  { key: "ac", label: "Κλιματισμός" },
  { key: "indoor", label: "Εσωτερικός χώρος" },
  { key: "outdoor", label: "Εξωτερικός χώρος" },
  { key: "parents_area", label: "Χώρος αναμονής γονέων" },
  { key: "public_transport", label: "Δημόσια συγκοινωνία" },
  { key: "cafe", label: "Καφετέρια / Κυλικείο" },
];

export const AMENITY_LABEL = Object.fromEntries(AMENITIES.map((a) => [a.key, a.label]));
